import PubSubUtils from '../utils/pubsub-utils';
import APP_CONSTANTS from '../constants';

export const publishConstellationLoadedEvent = () => {
  /* publish event for constellation loaded */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.BOOTSTRAP_SHELL_EVENTS.CONSTELLATION_LOADED, {});
};

export default { publishConstellationLoadedEvent };
